import moment from 'moment'
import isMobile from './isMobile'

const formatTime = (date: Date): string => {
  const formattedDate = moment.utc(date).format('YYYYMMDDTHHmmssZ')
  return formattedDate.replace('+00:00', 'Z')
}

export interface CalendarEvent {
  title: string
  description: string
  startTime: Date
}

export const buildUrl = (event: CalendarEvent, type: string, id: string): string => {
  let calendarUrl = ''

  // allow mobile browsers to open the gmail data URI within native calendar app
  // type = (type == "google" && this.isMobile()) ? "outlook" : type;

  switch (type) {
    case 'google':
      calendarUrl = 'https://calendar.google.com/calendar/render'
      calendarUrl += '?action=TEMPLATE'
      calendarUrl += '&dates=' + formatTime(event.startTime)
      calendarUrl += '/' + formatTime(moment(event.startTime).add(1, 'hours').toDate())
      calendarUrl += '&text=' + encodeURIComponent(`${event.title} Glass Premier`)
      calendarUrl +=
        '&details=' +
        encodeURIComponent('https://glass.xyz/watch/' + id + '\n\n' + event.description)
      calendarUrl += '&location=' + encodeURIComponent('https://glass.xyz/watch/' + id)
      break

    default:
      calendarUrl = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'BEGIN:VEVENT',
        'URL:' + 'https://glass.xyz/watch/' + id,
        'DTSTART:' + formatTime(event.startTime),
        'DTEND:' + formatTime(moment(event.startTime).add(1, 'hours').toDate()),
        'SUMMARY:' + `${event.title} Glass Premier`,
        'DESCRIPTION:' + event.description,
        'LOCATION:' + 'https://glass.xyz/watch/' + id,
        'END:VEVENT',
        'END:VCALENDAR',
      ].join('\n')

      if (isMobile()) {
        calendarUrl = encodeURI('data:text/calendar;charset=utf8,' + calendarUrl)
      }
  }

  return calendarUrl
}
